<template>
  <div>
    <b-form-checkbox
      @input="$emit('input', pickedServices)"
      v-model="pickedServices"
      v-for="service in allServices"
      :key="service.serId"
      :value="service.serId"
      :align="align"
    >
      {{ $t(service.serTranslationId) }}
      <font-awesome-icon
        :icon="['fas', 'info-circle']"
        @click.prevent="showModal(service.serTranslationId)"
      ></font-awesome-icon>
    </b-form-checkbox>
    <service-description-modals ref="modals" />
  </div>
</template>

<script>
import ServiceDescriptionModals from "./modals/ServiceDescriptionModals";
export default {
  name: "ServicePicker",
  components: { ServiceDescriptionModals },
  data() {
    return {
      pickedServices: []
    };
  },
  props: {
    align: String,
    value: Array,
    allServices: Array
  },
  methods: {
    showModal(translationId) {
      this.$refs["modals"].showModal("info-modal-" + translationId);
    }
  },
  watch: {
    value(newValue) {
      this.pickedServices = newValue;
    }
  }
};
</script>

<style scoped></style>
